<app-loader></app-loader>

<div class="iguau-feed" id="seccion-muro" *ngIf="perfil && (perfil | keyvalue)?.length">
  <header class="feed-heading" *ngIf="titulo">
    <span class="feed-heading-icon" aria-hidden="true"><i class="fa-solid fa-note-sticky"></i></span>
    <div class="feed-heading-content">
      <h2>{{ titulo }}</h2>
      <p *ngIf="subtitulo">{{ subtitulo }}</p>
    </div>
  </header>
</div>

<div class="iguau-feed-body">
<app-muro-acciones *ngIf="puedePublicar && muro" [tipo]="tipo" [tipoId]="tipoId" [misdatos]="misdatos" [perfil]="misdatos" [muro]="muro!"></app-muro-acciones>

<app-muro-filtros
  [paseosEstado]="paseosEstado"
  [ordenPublicaciones]="ordenPublicaciones"
  (paseosEstadoChange)="cambiarEstadoPaseos($event)"
  (ordenPublicacionesChange)="cambiarOrden($event)">
</app-muro-filtros>
<div class="iguau-feed-list">

<app-muro *ngFor="let muro of muros; trackBy: trackById"
          [muro]="muro"
          [perfil]="perfil"
          [misdatos]="misdatos"
          (comentarioCreado)="comentarioPublicado(muro)">
</app-muro>

<div *ngIf="finished && !muroService.loading && muros.length === 0" class="feed-empty"><i class="fa-solid fa-paw"></i><h3>Tu muro está listo para nuevas historias</h3><p>Aquí aparecerán publicaciones, paseos y novedades de la comunidad.</p></div>
<div class="w-100 text-center" style="min-height: 30px;">
  <div class="spinner-grow spinner-grow-sm text-iguau" role="status" *ngIf="muroService.loading">
    <span class="visually-hidden">Loading...</span>
  </div>          
</div>


</div>
</div>
